// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-pending {
    color: #e84118;
    font-weight: bold;
}

/* 관리자 견적 대기 페이지 스타일 */
.admin-main-content {
    display: flex;
    min-height: 100vh;
}

.admin-sidebar {
    width: 200px;
    background-color: #f8f9fa;
    padding: 20px;
    border-right: 1px solid #dee2e6;
}

.admin-content-quote {
    flex: 1 1;
    padding: 20px;
}

.page-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}

.page-title-bar {
    width: 4px;
    height: 24px;
    background-color: #e84118;
    margin-right: 10px;
}

.quote-table {
    width: 100%;
    border-collapse: collapse;
    background-color: white;
    border: 1px solid #dee2e6;
}

.quote-table th,
.quote-table td {
    border: 1px solid #dee2e6;
    padding: 12px 8px;
    text-align: center;
    vertical-align: middle;
}

.quote-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    font-size: 14px;
}

.quote-table tbody tr {
    cursor: pointer;
    transition: background-color 0.2s;
}

.quote-table tbody tr:hover {
    background-color: #f8f9fa;
}

/* 상품 정보 셀 스타일 - 이미지 크기 제한 */
.product-info-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    max-width: 250px; /* 셀 최대 너비 제한 */
}

.product-info-cell img {
    width: 50px !important;
    height: 40px !important;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    flex-shrink: 0; /* 이미지 크기 고정 */
}

.product-info-cell span {
    flex: 1 1;
    text-align: left;
    font-size: 13px;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

/* 검색 필터 스타일 */
.quote-search-filters {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.filter-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
}

.filter-row:last-child {
    margin-bottom: 0;
}

.filter-row label {
    min-width: 80px;
    font-weight: 500;
    font-size: 14px;
}

.filter-select,
.filter-input,
.filter-date {
    padding: 8px 12px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    font-size: 14px;
}

.filter-checkboxes {
    display: flex;
    gap: 15px;
}

.filter-checkboxes label {
    min-width: auto;
    font-weight: normal;
    display: flex;
    align-items: center;
    gap: 5px;
}

.search-button-quote {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 20px;
}

.search-button-quote:hover {
    background-color: #0056b3;
}

/* 목록 헤더 */
.quote-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding: 10px 0;
}

.btn-pdf-download {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
}

/* 목록 액션 버튼 */
.quote-list-actions {
    margin-top: 20px;
    display: flex;
    gap: 10px;
}

.btn-delete-selected,
.btn-edit-selected {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.btn-delete-selected {
    background-color: #dc3545;
    color: white;
}

.btn-edit-selected {
    background-color: #007bff;
    color: white;
}

.btn-delete-selected:hover {
    background-color: #c82333;
}

.btn-edit-selected:hover {
    background-color: #0056b3;
}

/* 반응형 디자인 */
@media (max-width: 1200px) {
    .product-info-cell {
        max-width: 200px;
    }
    
    .product-info-cell img {
        width: 40px !important;
        height: 32px !important;
    }
}

@media (max-width: 768px) {
    .admin-main-content {
        flex-direction: column;
    }
    
    .admin-sidebar {
        width: 100%;
    }
    
    .quote-table {
        font-size: 12px;
    }
    
    .product-info-cell {
        flex-direction: column;
        gap: 5px;
        max-width: 150px;
    }
    
    .product-info-cell img {
        width: 35px !important;
        height: 28px !important;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/QuotationPendingPage.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,gBAAgB,EAAE,eAAe;AACrC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc,EAAE,cAAc;AAClC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;IAGI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,UAAU;AACV;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,aAAa;AACb;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":[".status-pending {\n    color: #e84118;\n    font-weight: bold;\n}\n\n/* 관리자 견적 대기 페이지 스타일 */\n.admin-main-content {\n    display: flex;\n    min-height: 100vh;\n}\n\n.admin-sidebar {\n    width: 200px;\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-right: 1px solid #dee2e6;\n}\n\n.admin-content-quote {\n    flex: 1;\n    padding: 20px;\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.page-title-bar {\n    width: 4px;\n    height: 24px;\n    background-color: #e84118;\n    margin-right: 10px;\n}\n\n.quote-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: white;\n    border: 1px solid #dee2e6;\n}\n\n.quote-table th,\n.quote-table td {\n    border: 1px solid #dee2e6;\n    padding: 12px 8px;\n    text-align: center;\n    vertical-align: middle;\n}\n\n.quote-table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.quote-table tbody tr {\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.quote-table tbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n/* 상품 정보 셀 스타일 - 이미지 크기 제한 */\n.product-info-cell {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px;\n    max-width: 250px; /* 셀 최대 너비 제한 */\n}\n\n.product-info-cell img {\n    width: 50px !important;\n    height: 40px !important;\n    object-fit: cover;\n    border-radius: 4px;\n    border: 1px solid #dee2e6;\n    flex-shrink: 0; /* 이미지 크기 고정 */\n}\n\n.product-info-cell span {\n    flex: 1;\n    text-align: left;\n    font-size: 13px;\n    line-height: 1.3;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n/* 검색 필터 스타일 */\n.quote-search-filters {\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n}\n\n.filter-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n\n.filter-row:last-child {\n    margin-bottom: 0;\n}\n\n.filter-row label {\n    min-width: 80px;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.filter-select,\n.filter-input,\n.filter-date {\n    padding: 8px 12px;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.filter-checkboxes {\n    display: flex;\n    gap: 15px;\n}\n\n.filter-checkboxes label {\n    min-width: auto;\n    font-weight: normal;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.search-button-quote {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-bottom: 20px;\n}\n\n.search-button-quote:hover {\n    background-color: #0056b3;\n}\n\n/* 목록 헤더 */\n.quote-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n    padding: 10px 0;\n}\n\n.btn-pdf-download {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n/* 목록 액션 버튼 */\n.quote-list-actions {\n    margin-top: 20px;\n    display: flex;\n    gap: 10px;\n}\n\n.btn-delete-selected,\n.btn-edit-selected {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.btn-delete-selected {\n    background-color: #dc3545;\n    color: white;\n}\n\n.btn-edit-selected {\n    background-color: #007bff;\n    color: white;\n}\n\n.btn-delete-selected:hover {\n    background-color: #c82333;\n}\n\n.btn-edit-selected:hover {\n    background-color: #0056b3;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 1200px) {\n    .product-info-cell {\n        max-width: 200px;\n    }\n    \n    .product-info-cell img {\n        width: 40px !important;\n        height: 32px !important;\n    }\n}\n\n@media (max-width: 768px) {\n    .admin-main-content {\n        flex-direction: column;\n    }\n    \n    .admin-sidebar {\n        width: 100%;\n    }\n    \n    .quote-table {\n        font-size: 12px;\n    }\n    \n    .product-info-cell {\n        flex-direction: column;\n        gap: 5px;\n        max-width: 150px;\n    }\n    \n    .product-info-cell img {\n        width: 35px !important;\n        height: 28px !important;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
